import { Stack, styled } from '@mui/material'
import { ReactComponent as SvgMenu } from './assets/menu.svg'
import { memo, useState } from 'react'
import { FlexCenter, FlexItem } from 'styles'
import { OnlyDesktop } from 'styles/Media'
import { NetworkSelect } from 'views/Nav/NetworkSelect'
import { Logo } from './Logo'
import { Menu, MenuWrap } from './Menu'
import { NotificationView } from './Notification'
// import ThemeSwitch from './ThemeSwitch'
import { ConnectedAccount } from './ConnectedAccount'
import AccountPinIndex from './AccountPinIndex'
import { VersionSwitch } from './VersionFlag/VersionSwitch'
import { NavIndicator } from './NavIndicator'
import { useAtom } from 'jotai'
import { mobileMenuAtom } from './Menu/atoms'

const NavWrap = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 64px;
  gap: 12px;
  align-items: center;
  padding: 0 0 0 24px;
  border-bottom: 1px solid rgba(43, 49, 58, 1);
  /* border-bottom: 1px solid ${(props) => props.theme.color.text10}; */
  background: ${(props) => props.theme.color.bg};
  z-index: 100;

  ${(props) => props.theme.breakpoints.down('md')} {
    gap: 0;
    padding: 0 16px;
  }
`
const NavRight = styled(Stack)`
  flex-direction: row;
  align-items: center;
  height: 100%;
  padding: 0 12px;
  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 0;
  }
`
const MobileNavItem = styled(FlexCenter)`
  display: none;
  position: relative;
  min-width: 36px;
  max-width: 130px;
  height: 36px;
  background: ${(props) => props.theme.color.bg};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.theme.color.bgLightGray};
  border-radius: 6px;
  justify-content: center;

  ${(props) => props.theme.breakpoints.down('md')} {
    display: flex;
  }
`
const PcMenu = styled('div')`
  display: flex;
  height: 100%;
  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`
const MobileMenu = styled('div')`
  display: none;
  ${(props) => props.theme.breakpoints.down('md')} {
    display: block;
  }
`

export const Nav = memo(() => {
  const [showMenu, setShowMenu] = useAtom(mobileMenuAtom)

  return (
    <NavWrap id="zk_nav_wrap">
      <Logo />
      <PcMenu>
        <Menu />
      </PcMenu>
      {/*<MarketSearchBar />*/}
      <FlexItem />
      <AccountPinIndex />
      <VersionSwitch />
      <NavRight>
        <ConnectedAccount />
        <NetworkSelect />
        <NotificationView />
      </NavRight>
      <OnlyDesktop>{/* <ThemeSwitch /> */}</OnlyDesktop>
      <MobileNavItem onClick={() => setShowMenu(true)}>
        <SvgMenu />
      </MobileNavItem>
      {/* {showMenu && (
        <MobileMenu>
          <Menu />
        </MobileMenu>
      )} */}
      <NavIndicator />
    </NavWrap>
  )
})
